export default {
  // Sidebar
  'Nova OS Proativa': 'Neue proaktive OS',
  'Interno': 'Intern',
  'Externo': 'Extern',
  'Preventiva': 'Präventiv',
  'Preventiva Programada':  "Geplante präventive wartung",
  "Preventiva Programada Armazém": "Geplante präventive wartung Lager",
  'Reaberta': 'Wiedereröffnet',
  'Execuções': 'Ausführungen',
  'Armazém': 'Lager',
  'Frota': 'Fuhrpark',
  'Sair': 'Verlassen',
  'Inventário': 'Inventar',

  // Nova Os
  'Voltar': 'Zurück',
  'Nova OS': 'Neue OS',
  'Operação': 'Betrieb',
  'Placa': 'Kennzeichen',
  'Segmento': 'Segment',
  'Problemas': 'Probleme',
  'Descrição do Problema': 'Problembeschreibung',
  'Gerar OS': 'OS erzeugen',
  'Cancelar': 'Abbrechen',

  // OS Interna
  "Nenhum resultado encontrado": 'Kein Ergebnis gefunden',
  "Exibindo resultado": 'Ergebnis anzeigen',
  "de": 'von',
  "Aberta há": 'Geöffnet seit',
  "Concluída em": 'Abgeschlossen am',
  "Falha ao carregar os dados da OS": "Fehler beim Laden der OS-Daten",
  "Falha ao carregar os itens da OS": "Fehler beim Laden der OS-Elemente",

  // Ordem Servico
  "Detalhes": 'Details',
  "Mostrar": 'Anzeigen',
  "Esconder": 'Ausblenden',
  "Telefone": 'Telefon',
  "Data": 'Datum',
  "Início": 'Beginn',
  "Final": 'Ende',
  "Fornecedor": 'Lieferant',
  "Tipo": 'Typ',
  "Ciclo preventiva": 'Präventivzyklus',
  "Criticidade": 'Kritikalität',
  "Previsão de Atendimento": 'Serviceprognose',
  "Atendimento do Item": 'Artikelbearbeitung',
  "Observações": 'Hinweise',
  "Imagens": 'Bilder',
  "Salvar": 'Speichern',
  "Ordens de Serviço": 'Serviceaufträge',
  "GERADA_CHECKLIST": "GENERIERTE AUS CHECKLIST",
  "OBS_CHECKLIST": "CHECKLISTENHINWEISE:",
  "OS_INTERNA": "INTERNE OS:",

  // OS Item
  "Iniciar": 'Starten',
  "Ações": 'Aktionen',
  "Continuar": 'Fortsetzen',
  "Pausar": 'Pausieren',
  "Registrar Peças": 'Teile registrieren',
  "Cancelar OS": 'OS abbrechen',
  "OS Externa": 'Externe OS',
  "Insira um serviço. Tente novamente.": 'Geben Sie einen Service ein. Versuchen Sie es erneut.',

  // ModalItems
  "Serviços": 'Dienstleistungen',
  "SERVIÇOS": 'Dienstleistungen',
  "Observação": 'Hinweis',
  "Anexo de arquivos": 'Dateianhang',
  "Informe o valor total dos serviços/peças": 'Gesamtwert der Services/Teile angeben',
  "Informe o motivo do socorro em rota": 'Grund für Pannenhilfe angeben',
  "Informe o pneu utilizado neste serviço": 'Verwendeten Reifen angeben',
  "Foi trocado o pneu": 'Der Reifen wurde gewechselt',
  "Finalizar OS": 'OS abschließen',

  // Modal peças
  "Foi utilizado Peças?": 'Wurden Teile verwendet?',
  "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!":
    "Wenn bei diesem Service Teile verwendet wurden, drücken Sie unten 'Ja'!",
  "Não": 'Nein',
  "Sim": 'Ja',

  // Modal Itens Fim
  "Informe os itens utilizados neste serviço": 'Verwendete Artikel angeben',
  "Fechar": 'Schließen',
  "Peças": 'Teile',
  "Peça": 'Teil',
  "Quantidade": 'Menge',
  "Preço": 'Preis',
  "Informe o pneu novo": 'Neuen Reifen angeben',

  // Modal Pause
  "Informe a Justificativa": 'Begründung angeben',
  "Confirmar Pausa": 'Pause bestätigen',
  "Justificativa": 'Begründung',
  "Ir ao banheiro": 'Zur Toilette gehen',
  "Fim de expediente": 'Arbeitsende',
  "Atendimento": 'Service',
  "Refeição": 'Mahlzeit',
  "Aguardando Peças": 'Warten auf Teile',
  "Auxílio externo": 'Externe Hilfe',
  'Selecione qual peça está aguardando': 'Wählen Sie das wartende Teil',

  // Confirmar OS Externa
  "Confirmar OS Externa": 'Externe OS bestätigen',
  "Deseja realmente enviar OS": 'Möchten Sie die OS wirklich senden',
  "Confirmar": 'Bestätigen',

  // Lista de Execucao
  "Lista de execução": 'Ausführungsliste',
  "Nenhuma execução ativa": 'Keine aktive Ausführung',
  "Início Atendimento": 'Servicebeginn',
  "Encerrar OS": 'OS beenden',
  "Acessar OS": 'Auf OS zugreifen',
  "Colaborador": 'Mitarbeiter',
  "Execuções em Pause": 'Ausführungen in Pause',
  "Nenhuma execução em pause": 'Keine Ausführung in Pause',

  // Login
  "Torne sua rotina mais dinâmica": 'Machen Sie Ihre Routine dynamischer',
  "ACESSO AO SISTEMA": 'SYSTEMZUGANG',
  "Terminal Oficina": 'Werkstatt-Terminal',
  "Realize o login e tenha acesso ao controle": 'Melden Sie sich an und erhalten Sie Zugang zur Überwachung und Verwaltung Ihrer Serviceaufträge',
  "e gestão de suas Ordens de Serviço": 'und Verwaltung Ihrer Serviceaufträge',
  "Mecânico Externo": 'Externer Mechaniker',
  "Acessar": 'Zugreifen',
  "Falha ao fazer login": 'Fehler bei der Anmeldung',

  // Filtro Internas
  "Ordenar": 'Sortieren',
  "Antigas Primeiro": 'Älteste zuerst',
  "Recentes Primeiro": 'Neueste zuerst',
  "Maior": 'Größer',
  "Menor": 'Kleiner',
  "Segmentos": 'Segment',
  "Período": 'Zeitraum',
  "Execução": 'Ausführung',
  "Todos": 'Alle',
  "Pendentes": 'Offen',
  "Finalizadas": 'Abgeschlossen',
  "Aplicar filtro": 'Filter anwenden',
  "Limpar filtros": 'Filter löschen',
  "Esconder filtros": 'Filter ausblenden',
  "Criado por": 'Erstellt von',
  "Usuário": 'Benutzer',
  "Ação": "Aktion",

  // Os Preventivas
  "Filtre as OS Preventivas": 'Präventive Aufträge filtern',
  "Preventivas Vencidas": 'Abgelaufene Präventivmaßnahmen',
  "Preventivas à Vencer": 'Anstehende Präventivmaßnahmen',
  "Carrocerias Vencidas": 'Abgelaufene Karosseriearbeiten',
  "Carrocerias à Vencer": "Anstehende Karosseriearbeiten",
  "Atualizar": 'Aktualisieren',

  // Modais Preventivas
  "ACAO": 'Maßnahme',
  "PLACA": 'KENNZEICHEN',
  "PROXIMO_CICLO": 'NÄCHSTER_ZYKLUS',
  "VENCIMENTO": 'FÄLLIGKEIT',
  "PROXIMO_KM": 'NÄCHSTER_KM',
  "KM_ATUAL": 'AKTUELLER_KM',
  "Vincular Fornecedor": 'Lieferant verknüpfen',

  // Inventário
  'Iniciar novo inventário': 'Neues inventar starten',
  'Dt Inicial': 'Anfangsdatum',
  'Dt Final': 'Enddatum',
  "Não contados": 'Nicht gezählt',
  "Contados": 'Gezählt',
  "Ordenação": 'Sortierung',
  "Total Itens": 'Gesamtartikel',
  "Status": "Status",
  "Já existe um inventário em execução": "Es gibt bereits eine laufende Inventur",
  "Deseja iniciar um novo inventário?": "Möchten Sie eine neue Inventur starten?",
  "Inventário de Estoque": "Lagerbestand",

  // Modal Mecanico
  "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade":
    'Geben Sie die ersten drei Ziffern Ihres CPF ein, um Ihre Identität zu bestätigen',
  'Confirmar identidade': 'Identität bestätigen',

  "Erro do Motorista": 'Fahrerfehler',
  "Defeito não Encontrado": 'Kein Defekt gefunden',

  "Informe o serviço": 'Service angeben',
  "Insira os Itens": 'Artikel eingeben',

  "Alterar Fornecedor": 'Lieferant ändern',
  "Preventivas Armazém": 'Präventive Lager',
  "Outros": 'Sonstige',
  "Ver Encerradas": 'Abgeschlossene anzeigen',
  "Tem dúvida?": 'Haben Sie Fragen?',
  "Aguardando Aprovação": 'Warten auf Genehmigung',

  // Borracharia
  'Bem vindo(a) ao Terminal da Borracharia!': 'Willkommen im Reifen-Terminal!',
  'Realize a gestão de pneus pelo novo terminal da borracharia!':
  'Führen Sie die Reifenverwaltung am neuen Reifen-Terminal durch!',
  'Aferição': 'Prüfung',
  'Movimentação/Troca': 'Bewegung/Austausch',
  'Descarte': 'Entsorgung',
  'Borracharia': 'Reifenwerkstatt',
  'Placas': 'Kennzeichen',
  "Descartes": "Entsorgungen",
  // Gerais
  "Portugues": 'Português',
  "Nunca feito": 'Nie durchgeführt',
  "Ingles": 'Englisch',
  'Frances': "Französisch",
  'Alemao': 'Deutschland', 
  'Holandes': 'Niederländisch',
  'Espanhol': 'Spanisch',
  "Inventário criado com sucesso!": "Inventar erfolgreich erstellt!",
    
  "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "DIE ANSTRENGUNG VON HEUTE IST DER ERFOLG VON MORGEN",

  "CODIGO OS": "AUFTRAGSCODE",
  "TODOS": "ALLE",
  "Socorro em Rota pendente de atendimento": "Pannenhilfe ausstehend",
  "FILTROS": "FILTER",
  "Salvar Filtro": "Filter speichern",
  "Motorista": "Fahrer",
  "Orçamento": "Budget",
  "Confirmar Orçamento": "Budget bestätigen",
  "Deseja pausar esta OS para aguardar o orçamento?": "Möchten Sie diesen Arbeitsauftrag pausieren, um auf das Budget zu warten?",
  "Valor": "Wert",
  "Pausar OS": "Arbeitsauftrag pausieren",
  "Comentarios": "Kommentare",
  "Insira um comentário": "Kommentar eingeben",
  "Enviar OS": "Arbeitsauftrag senden",
  "Selecione uma justificativa": "Begründung auswählen",
  "Anexos": "Anhänge",
  "OS Socorro em Rotas": "Arbeitsauftrag Pannenhilfe",
  "Confirmar Cancelamento": "Stornierung bestätigen",
  "Buscar Placa": "Kennzeichen suchen",
  "Pesquisa de OS por placa": "Arbeitsauftragssuche nach Kennzeichen",
  "CONTRATO_CONCESSIONARIA": "KONZESSIONSVERTRAG",

  "Ordem gerada com sucesso": "Auftrag erfolgreich erstellt",
  "Sucesso": "Erfolg",
  "Selecionar Todos": "Alle auswählen",
  "Descrição": "Beschreibung",
  "Registrar Serviços": "Dienstleistungen registrieren",
  "Visualizar Itens": "Elemente anzeigen",
  "Clique no botão a direita para registrar as peças": "Klicken Sie auf die Schaltfläche rechts, um die Teile zu registrieren",

  "Selecionar técnico": "Techniker auswählen",
  "KM atual/Horimetro": "Aktueller Kilometerstand / Betriebsstundenzähler",
  "Deseja inserir alguma imagem no atendimento": "Möchten Sie dem Einsatz ein Bild hinzufügen?",
  "Para concluir a ação, selecione abaixo o técnico responsável": "Um die Aktion abzuschließen, wählen Sie unten den verantwortlichen Techniker aus",
  "Trabalhando": "In Arbeit",
  "Matricula": "MITARBEITER-NR",
  "Serviços registrado com sucesso": "Dienstleistungen erfolgreich registriert",
  "Função": "Funktion",
  "Enviar Anexos": "Anhänge senden",
  "Gerar Preventiva Programada": "Geplanter Wartungsauftrag generieren",
  "OS Preventiva Programada": "Geplanter Wartunsauftrag",
  "Finalize todas as peças e serviços para encerrar o atendimento": "Schließen Sie alle Teile und Dienstleistungen ab, um den Auftrag zu beenden",
  "Insira um KM maior que o anterior": "Geben Sie einen Kilometerstand ein, der höher als der vorherige ist",
  "Insira um KM maior que o atual": "Geben Sie einen Kilometerstand ein, der höher als der aktuelle ist",
  "Inserir anexos": "Anhänge hinzufügen",
  "Planos Preventivos": "Präventive Pläne",
  "Filtro": "Filter",
  "ULTIMA": "LETZTE",
  "Gerar Preditiva": "Prädiktive Wartung generieren",
  "Carregando": "Laden",
  "OS Preventiva Programada Armazém": "geplanter Lagerarbeitsauftrag",
  "Gerar OS Preventiva Programada": "Geplanten geplanter Lagerarbeitsauftrag",
  "OS Preventivas à Vencer": "Präventive Arbeitsaufträge vor Fälligkeit",
  "OS de Transição": "Übergangsbetriebssystem",

  "IMEDIATA": "SOFORT",
  "EMERGENCIAL": "NOTFALL",
  "ALTA": "HOCH",
  "MÉDIA": "MITTEL",
  "LEVE": "NIEDRIG",

  "Registrar Tarefas": "Aufgaben Registrieren",
  "Desbloqueia Empilhadeira": "Gabelstapler Entriegeln",
  "OS Ag. Aprovação": "Auftrag in Genehmigung",
  "OS Internas Veículos": "Interne Aufträge – Fahrzeuge",
  "OS Internas Armazém": "Interne Aufträge – Lager",
  "OS Reabertas": "Wiedereröffnete Aufträge",
  "Criticidade de OS Abertas": "Kritikalität Offener Aufträge",
  "Top 20 Placas com mais OS": "Top 20 Kennzeichen mit den Meisten Aufträgen",
  "Qtd OS": "Anzahl Aufträge",

  // Dashboard
  "Criticidade de OS abertas": "Kritikalität offener Aufträge",
  "URGENTE": "DRINGEND",
  "PREVENTIVA": "PRÄVENTIV",
  "CRITICIDADES": "KRITIKALITÄTEN",
  "Bem Vindo(a)": "Willkommen",
  "Tenha acesso as principais": "Erhalten Sie Zugang zu den wichtigsten",
  "informações da sua mecânica!": "Informationen Ihrer Werkstatt!",
  "Ver OS internas": "Interne Aufträge anzeigen",
  "OS TicketLog": "TicketLog Auftrag",
  "OS Externas": "Externe Aufträge",
  "OS Interna Veículos": "Interner Auftrag Fahrzeuge",
  "OS Interna Armazém": "Interner Auftrag Lager",
  "Ranking dos Mecânicos": "Mechaniker-Ranking",
  "Tipo de OS": "Auftragstyp",
  "Atendidas nos últimos 30 dias": "In den letzten 30 Tagen bearbeitet",
  "TOP 20 Placas com mais OS": "TOP 20 Kennzeichen mit den meisten Aufträgen",
  "Últimos 30 dias": "Letzte 30 Tage",
  "Placas com OS Externas": "Kennzeichen mit externen Aufträgen",
  "TOP 10 Problemas mais atendidos": "TOP 10 Meist bearbeitete Probleme",
  "Nos últimos 30 dias": "In den letzten 30 Tagen",
  "Status por Mecânico": "Status nach Mechaniker",
  "Produtividade": "Produktivität",

  // ModalEncerradas
  "Filtros": "Filter",
  "NÚMERO": "NUMMER",
  "INÍCIO": "BEGINN",
  "FINAL": "ENDE",
  "SEGMENTO": "SEGMENT",
  "PROBLEMA": "PROBLEM",
  
  // Login
  "Acesso Rápido": "Schnellzugriff",
  "ID": "ID",
  "CNPJ": "ID",
  "codigo_fornec": "code",
  "Para qual fornecedor você deseja enviar esta OS": "An welchen Lieferanten möchten Sie diese Bestellung senden",    
  'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!': "Falls Teile für diesen Service verwendet wurden, drücken Sie unten auf „Ja“!",
  'Precisa de Ajuda?': 'Hilfe benötigt?',
  "FILTRO EMPRESA": "NUR ``FILTER``",
  "Upload Arquivos": "Dateien hochladen",
  "Cards": "Cards",
  "Colunas": "Spalten",
  "ULTIMA MM": "LETZTE MM",
  "PRÓXIMA MM": "NÄCHSTE MM",
  "ULTIMA CAL": "LETZTE CAL",
  "PRÓXIMA CAL": "NÄCHSTE CAL",

  "ULTIMA MOVIMENTACAO": "LETZTE BEWEGUNG",
  "PRÓXIMA MOVIMENTACAO": "NÄCHSTE BEWEGUNG",
  "N° FOGO": "FEUER NR.",
  "FILIAL": "ZWEIG",
  "MARCA": "MARKE",
  "MODELO": "MODELL",
  "MEDIDA": "MAß",
  "POSIÇÃO": "POSITION",
  "Aguardando Aprovação de Sinistro": "Warten auf Schadensgenehmigung",
  "Aguardando Liberacao": "Warten auf Freigabe",
  "Nenhuma OS aguardando liberacao": "Keine Arbeitsaufträge warten auf Freigabe",
  
  "O tempo total é inferior a 5 minutos. Isso poderá impactar negativamente no controle de gestão": 
  "Die Gesamtzeit beträgt weniger als 5 Minuten. Dies kann sich negativ auf die Managementkontrolle auswirken",

  "Aguardar Liberação": "Freigabe ausstehend",

  "CONTRATO CONCESSIONARIA": "HÄNDLERVERTRAG",
  "Nenhuma OS aguardando aprovação": "Keine SOs, die auf Genehmigung warten",

    // Chaves adicionadas para i18n completo
    "Adicionar Serviços": "Dienste hinzufügen",
    "Aferindo NR Fogo": "NR Fogo messen",
    "AFERIÇÃO": "MESSUNG",
    "Aderência Aferição 01": "Haftung Messung",
    "Aderência Aferição 02": "Haftung Messung",
    "AÇÃO": "AKTION",
    "CALIBRAGEM": "KALIBRIERUNG",
    "CD_PNEU": "REIFEN_CODE",
    "CONJUNTO": "SATZ",
    "CPF (3 primeiros digitos)": "CPF (erste 3 Ziffern)",
    "Cadastro": "Registrierung",
    "Calibragem NR Fogo": "NR Fogo Kalibrierung",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo": "Geben Sie den Lieferantennamen ein, um ihn in der Liste unten anzuzeigen",
    "Confirmar envio Ticket": "Ticketversand bestätigen",
    "Conserto de Pneus": "Reifenreparatur",
    "DATA": "DATUM",
    "DS_PREDITIVO": "PRÄDIKTIVE BESCHREIBUNG",
    "DashBoard": "Dashboard",
    "Dashboard": "Dashboard",
    "Data Final": "Enddatum",
    "Data Inicial": "Startdatum",
    "Data OS": "OS-Datum",
    "Dentro do Prazo": "Fristgerecht",
    "Descartar": "Verwerfen",
    "Descarte Pneus": "Reifenentsorgung",
    "Deseja enviar para TicketLog a OS": "Möchten Sie die OS an TicketLog senden",
    "Digite para pesquisar": "Zum Suchen tippen",
    "Enviar": "Senden",
    "Equipamento Liberado": "Gerät freigegeben",
    "Escreva seu script aqui": "Schreiben Sie Ihr Skript hier",
    "Externas Armazém": "Externe Lager",
    "FOGO": "FEUER",
    "Fora do Prazo": "Überfällig",
    "Informar Aferição": "Messung eingeben",
    "Informar Calibragem": "Kalibrierung eingeben",
    "Informar KM": "KM eingeben",
    "Informar Sinistro": "Schaden melden",
    "Informe o KM do Pneu": "Reifen-KM eingeben",
    "Informe o serviço feito!": "Ausgeführten Service angeben!",
    "Insira o KM do veículo:": "Fahrzeug-KM eingeben:",
    "Insira os Serviços": "Dienste einfügen",
    "Inventário de estoque": "Bestandsinventar",
    "Inverter pneus": "Reifen tauschen",
    "Início Atendimento OS": "OS-Servicebeginn",
    "Item": "Artikel",
    "Itens:": "Artikel:",
    "KM": "KM",
    "KM PROX.": "NÄCHSTE KM",
    "Lançamento de item": "Artikeleingabe",
    "Lista": "Liste",
    "Matrícula": "Personalnummer",
    "Motivo": "Grund",
    "NR Fogo": "NR Fogo",
    "Novas Aferições": "Neue Messungen",
    "OS Encerradas - Últimas 15 OS": "Geschlossene OS - Letzte 15 OS",
    "OS Preventiva Vencida": "Überfällige präventive OS",
    "OS Preventivas Vencidas": "Überfällige präventive OS",
    "Observacao": "Hinweis",
    "PROX. CICLO": "NÄCHSTER ZYKLUS",
    "Para qual fornecedor você deseja enviar esta OS?": "An welchen Lieferanten möchten Sie diese OS senden?",
    "Pendente": "Ausstehend",
    "Pesquisa global": "Globale Suche",
    "Pesquisar": "Suchen",
    "Pesquisar Item": "Artikel suchen",
    "Pesquisar peça": "Teil suchen",
    "Pesquisar serviço": "Dienst suchen",
    "Planos": "Pläne",
    "Pneus a Placa:": "Reifen für Kennzeichen:",
    "Problema": "Problem",
    "Próximo Ciclo": "Nächster Zyklus",
    "Pular": "Überspringen",
    "Realizar avaliação": "Bewertung durchführen",
    "Registrar Aferições": "Messungen registrieren",
    "Selecione a empresa": "Unternehmen auswählen",
    "Selecione um Pneu": "Reifen auswählen",
    "Selecione um fornecedor": "Lieferanten auswählen",
    "Selecione um motivo": "Grund auswählen",
    "Servicos": "Dienstleistungen",
    "Serviço": "Dienst",
    "Sinalizar Sinistro": "Schaden kennzeichnen",
    "Sucesso!": "Erfolg!",
    "TIPO": "TYP",
    "Vencimento": "Fälligkeit",
    "de Calibragem": "der Kalibrierung",
    "Última Aferição": "Letzte Messung",
    "Última aferição NR fogo": "Letzte NR-Fogo-Messung",

    // Mensagens de validação
    "Preenchimento obrigatório": "Pflichtfeld",
    "Disponível": "Verfügbar",
    "Deve ser maior que 0": "Muss größer als 0 sein",
    "Não pode ser negativo": "Darf nicht negativ sein",
    "Valor Unitário": "Einzelwert",
    "Existem filtros salvos e aplicados": "Es gibt gespeicherte und angewendete Filter",
    "Adicionar Arquivos": "Dateien hinzufügen",
    "Ordem de Serviço criada com Sucesso": "Arbeitsauftrag erfolgreich erstellt",
    "Falha ao parar execução. Tente novamente": "Ausführung konnte nicht gestoppt werden. Bitte versuchen Sie es erneut.",
"Selecionar": "Auswählen",
"Insira todas as informações": "Geben Sie alle Informationen ein",
"Item registrado com sucesso": "Element erfolgreich registriert",
"Insira um preço": "Geben Sie einen Preis ein",
"OS Preventiva A Vencer": "Präventive Arbeitsaufträge mit bevorstehender Fälligkeit",
"OS já está aberta": "Der Arbeitsauftrag ist bereits geöffnet",
"Não trabalhando": "Arbeitet nicht",

"ABASTECIMENTO": "BETANKUNG",
"CHECKLIST": "CHECKLISTE",
"CHECKLIST CONFORMIDADE": "KONFORMITÄTSPRÜFLISTE",
"PREVENTIVA CARROCERIA": "VORBEUGENDE KAROSSERIEWARTUNG",
"SOCORRO EM ROTA": "PANNENHILFE",
}
